module.exports = __webpack_public_path__ + "img/page_right.826a8fd7.svg";